{
  "welcome": "歡迎來到",
  "instructions": "點選下方按鈕開始報到流程。",
  "startCheckIn": "開始報到",
  "missingWarehouseTitle": "缺少倉庫資訊",
  "missingWarehouseMessage": "此連結無效，連結中必須包含倉庫 ID",
  "recaptchaAttribution": "本網站受 reCAPTCHA 保護，並適用 Google 的{privacyPolicy}和{termsOfService}。",
  "recaptchaPrivacyPolicy": "隱私權政策",
  "recaptchaTermsOfService": "服務條款",
  "lookupTitle": "新增參考編號或確認號碼以查詢您的預約",
  "referenceNumberLabel": "參考編號或確認號碼",
  "referenceNotFoundError": "此參考編號或確認號碼與任何有效預約都不相符。",
  "checkIn": "報到",
  "loadTypeLabel": "貨物類型",
  "directionLabel": "方向",
  "operationLabel": "作業",
  "dockLabel": "月台",
  "orDivider": "或",
  "noReferenceTitle": "我沒有確認號碼",
  "noReferenceDescription": "使用標準報到流程，在沒有預約的情況下繼續。",
  "checkInWithoutAppointment": "無預約報到",
  "readyToCheckInTitle": "準備好報到了嗎？",
  "readyToCheckInDescription": "點選下方開始。您將在下一個畫面輸入您的資料。",
  "referenceRequiredHint": "在此地點報到需要提供參考編號。",
  "haveAppointment": "我有預約",
  "direction": {
    "inbound": "進貨",
    "outbound": "出貨",
    "inOut": "進貨與出貨",
    "load": "裝貨",
    "unload": "卸貨"
  },
  "operation": {
    "live": "現場裝卸",
    "drop": "甩掛",
    "other": "其他"
  }
}
